import { useTheme as a, getSizeValue as u } from "@bedrock-layout/spacing-constants";
import { forwardRefWithAs as y } from "@bedrock-layout/type-utils";
import d from "react";
const C = y(
  ({ as: t, centerChildren: r, centerText: o, maxWidth: e, style: n, ...c }, s) => {
    const m = a(), p = [
      o && "center-text",
      r && "center-children"
    ].filter((l) => l).join(" "), f = n ?? {}, i = t ?? "div";
    return /* @__PURE__ */ d.createElement(
      i,
      {
        "data-bedrock-center": p,
        ref: s,
        style: {
          "--maxWidth": typeof e == "number" && e > 0 ? `${e}px` : u(m, e) ?? e,
          ...f
        },
        ...c
      }
    );
  }
);
C.displayName = "Center";
export {
  C as Center
};
